module.exports = __webpack_public_path__ + "static/render-a8b944e629a87e1e21428dbcca6caf63.gif";